// extracted by mini-css-extract-plugin
export default {"layout":"layout___euksS","menu":"menu___R1KbF"};